export default __webpack_public_path__ + "static/media/aveiro.ac0fa71a.jpg";